import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class PlanSalesService {
  getPlans() {
    return securedAxiosInstance.get("/plan_sales", {
      params: {
        includes: [
          "scheduled_cancellation",
          "plan_sale_product",
          "plan_sale_contract",
          "plan_sale_contract.plan_sale_coverages",
          "contract_updates",
          "formula_change_letter",
        ],
      },
    });
  }

  getPlan(planSaleFriendlyId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleFriendlyId}`, {
      params: {
        includes: [
          "scheduled_cancellation",
          "plan_sale_product",
          "plan_sale_contract",
          "plan_sale_contract.plan_sale_coverages",
          "claims",
          "claims.claim_product",
          "formula_change_letter",
        ],
      },
    });
  }

  cancelPlan(planSaleFriendlyId, params) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleFriendlyId}/cancel`, toSnakeCase(params));
  }

  scheduleCancellation(params) {
    return securedAxiosInstance.post("/scheduled_cancellations", toSnakeCase(params));
  }

  deleteProductItem(planSaleId, productItemId) {
    return securedAxiosInstance.delete(`/plan_sales/${planSaleId}/product/composed_product_items/${productItemId}`);
  }

  addProductItem(planSaleId, formData) {
    return securedAxiosInstance.post(`/plan_sales/${planSaleId}/product/composed_product_items`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  updateProductItem(planSaleId, productItemId, formData) {
    return securedAxiosInstance.put(
      `/plan_sales/${planSaleId}/product/composed_product_items/${productItemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  }

  getPlanMembershipAgreement(planSaleFriendlyId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleFriendlyId}/membership_agreement`);
  }

  getPaymentMethod(planSaleId) {
    return securedAxiosInstance.get(`/customer/payment_methods/${planSaleId}`);
  }

  getPlanSepaMandate(planSaleFriendlyId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleFriendlyId}/sepa_mandate`);
  }

  getPaymentMethods() {
    return securedAxiosInstance.get("/customer/payment_methods");
  }

  getUpdatePaymentMethodLink(planSaleId) {
    return securedAxiosInstance.get(`/customer/payment_methods/update_link?plan_sale_id=${planSaleId}`);
  }

  declareProductExchange(friendlyId, params) {
    return securedAxiosInstance.put(`/plan_sales/${friendlyId}/exchange_product`, toSnakeCase(params));
  }
}

export default new PlanSalesService();
